// extracted by mini-css-extract-plugin
export var container = "UpdateItem-module--container--N9sqZ";
export var quantityInput = "UpdateItem-module--quantityInput--XQeaL";
export var title = "UpdateItem-module--title--HLFQX";
export var top = "UpdateItem-module--top--qSxv5";
export var updateQuantity = "UpdateItem-module--updateQuantity--8gFFF";